export default __webpack_public_path__ + "static/media/Product-Sans-Bold.53df38d5.ttf";